import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
const OVERLAY_FONT_SIZE = 9;
const OVERLAY_LINE_HEIGHT = 12;
const OVERLAY_PADDING = 4;
const OVERLAY_BG_OPACITY = 0.06;
function formatOverlayDate(raw) {
    try {
        return new Date(raw).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    }
    catch {
        return raw;
    }
}
function drawSignatureOverlay(page, field, font) {
    const { width: pageWidth, height: pageHeight } = page.getSize();
    const x = (field.xPct / 100) * pageWidth;
    const y = pageHeight - (field.yPct / 100) * pageHeight;
    const boxWidth = (field.widthPct / 100) * pageWidth;
    const boxHeight = (field.heightPct / 100) * pageHeight;
    page.drawRectangle({
        x,
        y: y - boxHeight,
        width: boxWidth,
        height: boxHeight,
        color: rgb(0.85, 0.92, 1.0),
        opacity: OVERLAY_BG_OPACITY,
    });
    const lines = [];
    lines.push(`Signed by ${field.name}`);
    if (field.date) {
        lines.push(`Date: ${formatOverlayDate(field.date)}`);
    }
    if (field.id) {
        lines.push(`ID: ${field.id}`);
    }
    let textY = y - OVERLAY_PADDING - OVERLAY_FONT_SIZE;
    for (const line of lines) {
        if (textY < y - boxHeight) {
            break;
        }
        page.drawText(line, {
            x: x + OVERLAY_PADDING,
            y: textY,
            size: OVERLAY_FONT_SIZE,
            font,
            color: rgb(0.1, 0.1, 0.1),
            maxWidth: boxWidth - OVERLAY_PADDING * 2,
        });
        textY -= OVERLAY_LINE_HEIGHT;
    }
}
/**
 * Renders signature overlay text onto the given PDF bytes using pdf-lib.
 * Each overlay is positioned at its percentage-based coordinates on the
 * target page, preserving the original PDF's vector text and accessibility.
 */
export async function generateSignedPdf({ pdfBytes, signatures }) {
    const pdfDoc = await PDFDocument.load(pdfBytes, { ignoreEncryption: true });
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const pages = pdfDoc.getPages();
    for (const field of signatures) {
        const pageIndex = field.page - 1;
        if (pageIndex < 0 || pageIndex >= pages.length) {
            continue;
        }
        drawSignatureOverlay(pages[pageIndex], field, font);
    }
    return pdfDoc.save();
}
export async function generateSignedPdfFile(args, fileName = 'signed_consent.pdf') {
    const bytes = await generateSignedPdf(args);
    return new File([bytes], fileName, { type: 'application/pdf' });
}
